import { AntdProTable, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DocumentoConciliadoGetCuentaBancariaMovimientosDtoProps } from "api/DTOs/DocumentoConciliadoGetCuentaBancariaMovimientosDto"
import {
  DOCUMENTO_CONCILIABLE,
  DocumentoConciliableType,
} from "api/Types/DocumentoConciliable"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useTranslation } from "react-i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { MODAL_DOCUMENTOS_CONCILIADOS_COLUMNS } from "./ModalDocumentosConciliadosColumns"

export const conciliableTipos: Array<DocumentoConciliableType> = [
  DOCUMENTO_CONCILIABLE.DEVOLUCION,
  DOCUMENTO_CONCILIABLE.AMORTIZACION,
  DOCUMENTO_CONCILIABLE.FLUJO_TESORERIA,
]

export const ModalDocumentosConciliados = ({
  isOpen = true,
  data,
  onCancel,
}: {
  isOpen: boolean
  data?: Array<DocumentoConciliadoGetCuentaBancariaMovimientosDtoProps> | null
  onCancel?: () => void
}) => {
  const { t } = useTranslation()
  const importeConciliado = frontendCurrency(
    data?.reduce((acc, item) => acc + (item.importe || 0), 0) ?? 0
  )

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-256 !tw-p-0 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-between tw-items-center tw-p-6 tw-pb-4'>
          <span className='tw-text-2xl tw-font-medium tw-text-primary'>
            {t("bancos.idView.modalReconciled.header")}
          </span>

          <FontAwesomeIcon
            icon={["fal", "xmark"]}
            className='tw-cursor-pointer tw-text-gray-500 tw-py-1 tw-px-2 tw-h-5 hover:tw-bg-gray-100 tw-rounded tw-transition-colors tw-duration-200'
            onClick={onCancel}
          />
        </div>
      }
    >
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base'>
        <p className='tw-mb-6 tw-px-6'>
          {t("bancos.idView.modalReconciled.amountConciliated")}
          <span className='tw-text-secondary tw-pl-1'>{importeConciliado}</span>
        </p>
        <div className='tw-bg-background tw-min-h-100 tw-rounded-b-lg tw-max-h-96 tw-overflow-y-auto tw-mb-4'>
          <AntdProTable
            data-testid='tabla-modal-documentos-conciliados'
            id='tabla-modal-documentos-conciliados'
            rowKey='id'
            defaultSelectionModeAll={false}
            columns={MODAL_DOCUMENTOS_CONCILIADOS_COLUMNS(t)}
            dataSource={data}
            rowSelection={false}
            pagination={false}
          />
        </div>
      </div>
    </PrimeReactModal>
  )
}
